<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
        <el-button type="primary" size="small" @click="addActivity()">增加活动</el-button>
        <el-button type="primary" size="small" @click="typeListConfig()">体验营类型管理</el-button>
<!--        <el-button type="primary" size="small" @click="orderList()">体验营数据</el-button>-->
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="id" label="活动ID" width="90"></el-table-column>
        <el-table-column prop="title" label="标题" width="200"></el-table-column>
        <el-table-column label="礼品信息">
          <template slot-scope="{row}">
            <div>{{ row.invited_give_id_1_title }}</div>
            <div>{{ row.invited_give_id_2_title }}</div>
            <div>{{ row.invited_give_id_3_title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="活动时间" width="180">
          <template slot-scope="{row}">{{ row.start_at }} ~ {{ row.end_at }}</template>
        </el-table-column>
        <el-table-column prop="camp_price" label="体验营价格" width="100"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="updateAssist(row.id)">活动信息</el-button>
            <el-button type="primary" size="small" @click="pageElementConfig(row.id)">页面配置</el-button>
            <el-button type="primary" size="small" @click="pageIdConfig(row.id)">体验营配置</el-button>

            <template v-if="row.status == 1">
              <el-button type="danger" size="small" @click="updateOnline(row.id, 'offline')">下架</el-button>
            </template>
            <template v-else>
              <el-button type="success" size="small" @click="updateOnline(row.id, 'online')">上架</el-button>
            </template>

            <template v-if="row.status == 0">
              <el-button type="danger" size="small" @click="deleteActivity(row.id)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getList, updateOnline, deleteActivityInfo
} from "@/api/activityCamp";

export default {
  data:function () {
    return {
      listData:[],
      listLoading:false,
      listTotal:0,
      query:{
        limit:20,
        page:1
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },
    typeListConfig(){
      this.$router.push({
        path: "/activity/camp/typeList",
      });
    },
    orderList(){
      this.$router.push({
        path: "/activity/camp/orderList"
      });
    },
    pageElementConfig(id){
      this.$router.push({
        path: "/activity/camp/pageElementConfig",
        query: {id:id}
      });
    },
    pageIdConfig(id){
      this.$router.push({
        path: "/activity/camp/pageIdConfig",
        query: {id:id}
      });
    },
    updateAssist(id){
      this.$router.push({
        path: "/activity/camp/info",
        query: {type:'update', id:id}
      });
    },
    addActivity(){
      this.$router.push({
        path: "/activity/camp/info",
        query: {type:'create'}
      });
    },
    updateOnline(id,type){
      this.listLoading = true;
      updateOnline({id,type}).then(response => {
        this.listLoading = false;
        if(response.code == 1){
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    deleteActivity(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteActivityInfo({id}).then(response => {
          this.listLoading = false;
          if(response.code == 1){
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    copy(url){
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return url
        }
      })
      clipboard.on('success', e => {
        this.$message({
          showClose: true,
          duration: 3000,
          message: '复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>